/**
 * Created by Andrew on 6/10/2016.
 */

import React, { Component } from 'react';
import CustomerStatistics from '../presentation/customer-statistics';

export default class CustomerStatisticsWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statistics: {}
        }
    }

    componentWillMount() {
        // TODO: load statistics  from BigQuery
        // this.refreshCustomer();
    }

    refreshCustomer = () => {
        let params = 'id='+this.props.account._id;

        fetch("/service/customerStatistics?"+params, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then(response => {
            if( response.status != 200 ) {
                response.json().then(json => {
                    this.handleError(json, this);
                    return;
                });
            } else {
                response.json().then(json => {
                    this.setState({ statistics: json });
                });
            }
        }).catch(console.error);
    };

    render() {
        return <CustomerStatistics statistics={this.state.statistics} />
    }
}